import { orderDataEdit } from 'app/orderDataTmp'
import { SET_NEW_ORDER_DATA } from '../actions/OrderEditAction'

const initialState = [...orderDataEdit];

const OrderEditReducer = function (state = initialState, action) {
    // console.log('Запускаем замену стета ', action.type);
    switch (action.type) {
        case SET_NEW_ORDER_DATA: {
            // console.log('Должны заменить редактируемый заказ',state,action.payload);
            return [...action.payload]
        }
        default: {
            // console.log('Неа ', action.type);
            return [...state]
        }
    }
}

export default OrderEditReducer
